export default "__VITE_ASSET__DuHJG7tE__"